import * as styles from './Unauthorized.module.scss';
import { WithAlert } from '@components/design';

import { feedback } from '@ecosystem/newron-design-system';

const { ActionType } = feedback;

export const Unauthorized = () => {
  return (
    <div className={styles.Unauthorised__Wrapper}>
      <WithAlert title="You are not authorised to view any data." type="error" actionType={ActionType.DEFAULT} />
    </div>
  );
};
